<template>
	<div class="">
		<!-- Top Section: Yellow Background with Tim and Jack Image -->
		<section class="top-section-yellow">
			<div class="tim-jack-image-wrapper">
				<img
					src="/images/TS2.webp"
					alt="Tim Sykes"
					class="tim-jack-cutout min-h-[182px]"
					loading="lazy"
					width="300"
					height="450"
				/>
				<img
					src="/images/JK1.webp"
					alt="Jack Kellogg"
					class="tim-jack-cutout min-h-[164px]"
					loading="lazy"
					width="300"
					height="417"
				/>
			</div>
		</section>

		<Row class="bg-primary-900">
			<Container class="flex flex-col w-full !mx-auto">
				<!-- Bottom Section: Dark Blue Background -->
				<div class="lg:py-16 relative">
					<!-- Title Section -->
					<div class="section-content-wrapper">
						<div class="w-full mx-auto">
							<h2
								class="text-white text-center font-bold leading-tight lg:leading-tight mb-6 text-sec-title"
							>
								My Top Student
								<span class="highlight-yellow">Jack Kellogg</span>
								Was a Valet in 2017: Now He's Up to
								<span class="highlight-yellow">$26 Million</span>
								in Trading Profits!
							</h2>
						</div>
					</div>

					<!-- Centered Paragraph Text -->
					<div class="mx-auto mb-8 lg:mb-12">
						<p
							class="text-white text-center text-xl lg:text-3xl leading-relaxed"
							v-html="paragraphText"
						/>
					</div>

					<!-- Video Section - Full Width Centered -->
					<div class="video-container mb-8 lg:mb-12">
						<div
							class="wistia-video-2 relative mx-auto"
							style="background-image: url('/images/tim-and-jack.webp')"
						>
							<div id="youtube-player-2" />
							<nuxt-link
								class="play-btn"
								:to="ctaUrl"
								target="_blank"
							>
								<svg
									width="169"
									height="169"
									viewBox="0 0 169 169"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<circle
										cx="84.5645"
										cy="84.1023"
										r="83.9826"
										fill="url(#paint0_radial_1196_7910)"
									/>
									<defs>
										<radialGradient
											id="paint0_radial_1196_7910"
											cx="0"
											cy="0"
											r="1"
											gradientUnits="userSpaceOnUse"
											gradientTransform="translate(84.5645 84.1023) rotate(90) scale(90.7907)"
										>
											<stop
												stop-color="white"
												stop-opacity="0"
											/>
											<stop
												offset="1"
												stop-color="#C5DCFF"
											/>
										</radialGradient>
									</defs>
								</svg>
								<img
									src="/images/icons/play-arrow.svg"
									width="116"
									height="116"
									alt="play video"
								/>
							</nuxt-link>
						</div>
					</div>

				<CtaButton
					:to="ctaUrl"
					class="mx-auto text-center mt-8 lg:mt-12 cta-large"
						:blank="true"
						dataCtaType="live-masterclass-webinar"
						:hide-arrow="true"
					>
						<span class="text-xl lg:text-4xl font-bold py-2 lg:px-4">
							Get Jack's Free Training Here!
						</span>
					</CtaButton>
				</div>
			</Container>
		</Row>
	</div>
	<Head>
		<Style>#youtube-player-2 { width: 560px; height: 315px; }</Style>
	</Head>
</template>

<script setup>
const playVideo = ref(false);

const ctaUrl = useCampaignUrl(
	"https://trading.jackkelloggtrading.com/jrt-holiday/step/jrt-cart1/?utm_source=124&utm_medium=affiliate&utm_campaign=1n2d2A&utm_content=&utm_term=&ef_tid=643b6be0fe514724945a221e66eb3b86&ef_oid=70&ef_aid=124"
);

const paragraphText = computed(() => {
	return `Watch how he turned a $10,000 retirement account into over <span class="highlight-yellow"><strong>$4.1 million</strong></span> in just over a year WITHOUT crypto, options or forex...`;
});

function onYouTubeIframeAPIReady() {
	if (
		!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')
	) {
		const script = document.createElement("script");
		script.setAttribute("src", "https://www.youtube.com/iframe_api");
		script.setAttribute("async", true);
		document.head.appendChild(script);
	}

	setTimeout(() => {
		playVideo.value = true;
		player = new YT.Player("youtube-player-2", {
			videoId: "JdYdAFGpNaI", // Replace with your video's ID
			playerVars: {
				autoplay: true, // Autoplay is turned off
				controls: 1, // Show video controls
				modestbranding: 1, // Hide the YouTube logo
				rel: 0
			}
		});
	}, 500);
}
</script>

<style lang="scss">
@import "@assets/utils.scss";

.join-webinar-section {
	background-color: black;
	overflow: hidden;
	position: relative;
}

.top-section-yellow {
	background-color: $secondary-500;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0;
}

.top-blue-bar,
.bottom-blue-bar {
	width: 100%;
	background-color: $primary-900;
	height: 8px;

	@include breakpoint(md) {
		height: 12px;
	}
}

.top-blue-bar {
	margin-bottom: 0;
}

.bottom-blue-bar {
	margin-top: 0;
}

.section-content-wrapper {
	position: relative;
	margin-bottom: 16px;
}

.video-container {
	width: 100%;
	// max-width: 900px;
	margin: 0 auto;
}

.arrow-icon {
	flex-shrink: 0;
	display: none;
	@include breakpoint(md) {
		display: block;
		width: 124px;
		height: 124px;
	}
}

.tim-jack-image-wrapper {
	position: relative;
	margin: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: flex-end;
	gap: 0;
	padding: 24px 16px 0;

	@include breakpoint(md) {
		padding: 32px 24px 0;
		gap: 8px;
	}

	@include breakpoint(lg) {
		padding: 40px 32px 0;
		gap: 16px;
	}
}

.tim-jack-cutout {
	width: auto;
	height: auto;
	max-width: 140px;
	max-height: 300px;
	object-fit: contain;
	display: block;

	@include breakpoint(md) {
		max-width: 300px;
		max-height: 400px;
	}

	@include breakpoint(lg) {
		max-width: 350px;
		max-height: 450px;
	}

	@include breakpoint(xl) {
		max-width: 400px;
		max-height: 500px;
	}
}

.wistia-video-2 {
	width: 100%;
	aspect-ratio: 16 / 9;
	// max-width: 900px;
	display: block;
	position: relative;
	background-color: #000;
	background-size: cover;
	background-position: center;
	border-radius: 4px;
	overflow: hidden;
}

.play-btn {
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	margin: auto;
	display: flex;
	justify-content: center;
	align-items: center;

	&::before {
		position: absolute;
		content: "";
		height: 52px;
		width: 52px;
		background-color: white;
		z-index: 0;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}
	svg {
		position: absolute;
		margin: auto;
		top: 0;
		left: -25%;
		right: -25%;
		bottom: 0;
		z-index: 0;
		animation: blink 2s infinite;
	}

	img {
		position: relative;
		z-index: 1;
	}
}

@keyframes blink {
	0% {
		opacity: 0.5;
	}

	50% {
		opacity: 1;
	}

	100% {
		opacity: 0.5;
	}
}

iframe#youtube-player-2 {
	width: 100%;
	height: 100%;
}

.as-sees-on-desktop {
	display: none;
	margin: auto;
	@include breakpoint(md) {
		display: block;
	}
}

.as-sees-on-mobile {
	display: flex;
	flex-direction: column;
	@include breakpoint(md) {
		display: none;
	}
}

.text-sec-title {
	font-size: 28px;
	@include breakpoint(md) {
		font-size: 36px;
	}
	@include breakpoint(lg) {
		font-size: 48px;
	}
	@include breakpoint(xl) {
		font-size: 64px;
	}
}
</style>
